import { conversion } from "@/tool";
import Picture from '@/components/picture';
import Button from '@/components/button';
import Avatar from '@/components/avatar';
import Award from '@/components/award';
import { CustomBlockTitle } from '@/partials/custom_block_title';
import { mapState, mapMutations } from 'vuex';
import { ParentMessageBridge, GAME_EVENTS, COMMANDS } from '@/utils/MessageBridge';
import Cookies from "@/utils/cookie";

export default {
  name: 'Poggi',
  components: {
    'c-picture': Picture,
    'c-button': Button,
    'c-avatar': Avatar,
    'c-award': Award
  },
  filters: {
    conversion
  },
  data() {
    return {
      messenger: null,
      isInitialized: false // 防止重复初始化
    };
  },
  computed: {
    ...mapState(["user"]),
    currencyType() {
      return Number(this.$route.meta.currencyType ?? this.$route.query.currencyType ?? 0);
    },
  },
  watch: {
    // 监听用户登录状态，如果从没登录变为登录，自动初始化
    'user.nickname': function (newVal) {
      if (newVal) {
        this.$nextTick(() => this.initGameMessager());
      }
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 0);
    });

    if (this.user.nickname) {
      this.initGameMessager();
    }
  },
  beforeDestroy() {
    // 彻底销毁监听器，防止内存泄漏
    this.removeFullscreenListeners();
    if (this.messenger) {
      // 如果 Bridge 有销毁方法请调用
      this.messenger = null;
    }
  },
  methods: {
    ...mapMutations(["setloginModal", "setPayModal", "setInfo"]),

    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    setLogin() {
      return this.$store.commit('setloginModal', true);
    },

    async initGameMessager() {
      // 1. 确保 ref 存在且不重复初始化
      if (this.isInitialized || !this.$refs.gameIframe) return;

      const iframe = this.$refs.gameIframe;
      this.messenger = new ParentMessageBridge(iframe, "*");

      // 2. 绑定事件逻辑
      this.setupMessageHandlers();

      // 3. 加载页面
      iframe.src = `/poggi-app/index.html?currencyType=${this.currencyType}`;
      this.isInitialized = true;
    },

    setupMessageHandlers() {
      // 初始化
      this.messenger.on(GAME_EVENTS.INIT).add(() => {
        console.log("收到游戏端 Init 信号");
      });

      // Token 请求
      this.messenger.on(GAME_EVENTS.TOKEN_REQUEST).add(() => {

        const getCookieToken = Cookies.getToken();

        this.messenger.send(COMMANDS.TOKEN, {
          token: getCookieToken || "",
          url: window.configs?.serveBaseURL + `/poggi/${this.currencyType}/`
        });
      });

      // 语言请求
      this.messenger.on(GAME_EVENTS.LCID_STRING_REQUEST).add(() => {
        this.messenger.send(COMMANDS.LCID_STRING, { lcid: 'cn' });
      });

      // 全屏切换
      this.messenger.on(GAME_EVENTS.FULLSCREEN_CLICK).add((data) => {
        this.toggleFullscreen(data.fullscreen);
      });

      // 余额不足
      this.messenger.on(GAME_EVENTS.BALANCE_NOT_ENOUGH).add(() => {
        this.setPayModal(true);
      });

      // 余额变更
      this.messenger.on(GAME_EVENTS.BALANCE_CHANGE).add(() => {
        this.setInfo(true);
      });
    },

    /**
     * 全屏兼容性逻辑
     */
    toggleFullscreen(enable) {
      if (!this.checkFullscreenAvailability()) {
        console.warn("当前浏览器不支持全屏 API");
        return;
      }
      enable ? this.enterFullscreen() : this.exitFullscreen();
    },

    enterFullscreen() {
      const el = this.$refs.gameIframe;
      if (!el) return;

      // 兼容各浏览器的全屏请求方法
      const requestMethod =
        el.requestFullscreen ||
        el.webkitRequestFullscreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;

      if (requestMethod) {
        requestMethod.call(el).catch(err => {
          console.error(`进入全屏失败: ${err.message}`);
        });
      }

      // 添加多个前缀的监听
      this.addFullscreenListeners();
    },

    exitFullscreen() {
      const doc = document;
      const exitMethod =
        doc.exitFullscreen ||
        doc.webkitExitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.msExitFullscreen;

      if (exitMethod && this.getFullscreenElement()) {
        exitMethod.call(doc);
      }
    },

    checkFullscreenAvailability() {
      return !!(
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      );
    },

    getFullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
    },

    addFullscreenListeners() {
      const events = [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange",
        "MSFullscreenChange"
      ];
      events.forEach(event => {
        document.addEventListener(event, this.onFullscreenStatusChange);
      });
    },

    removeFullscreenListeners() {
      const events = [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange",
        "MSFullscreenChange"
      ];
      events.forEach(event => {
        document.removeEventListener(event, this.onFullscreenStatusChange);
      });
    },

    onFullscreenStatusChange() {
      const isFullscreen = !!this.getFullscreenElement();
      if (this.messenger) {
        this.messenger.send(COMMANDS.SET_FULLSCREEN, {
          fullscreen: isFullscreen
        });
      }

      if (!isFullscreen) {
        this.removeFullscreenListeners();
      }
    }
  }
}
